import React from 'react'
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import MuiDialogContent from '@material-ui/core/DialogContent';
import MuiDialogActions from '@material-ui/core/DialogActions';
import {makeStyles, withStyles} from '@material-ui/core/styles';
import {Container, Typography} from '@material-ui/core';
import {useHistory} from 'react-router-dom';

const useModalStyles = makeStyles((theme) => ({

    fontStyle: {fontWeight: 'bold', fontFamily: 'Times New Roman'},
    spaceStyle: {display: 'flex', justifyContent: 'space-between'},
    centerStyle: {textAlign: 'center'},
    imageStyle: {width: "400px", height: "400px", float: "left"},
    contentStyle: {float: "left", width: "450px"},

}));

const DialogContent = withStyles((theme) => ({
    root: {
        padding: theme.spacing(2),
    },
}))(MuiDialogContent);


const DialogActions = withStyles((theme) => ({
    root: {
        margin: 0,
        padding: theme.spacing(1),
    },
}))(MuiDialogActions);


export const ItemDetails = (props) => {

    const classes = useModalStyles();
    const {open, setOpen, item} = props;
    const navigation = useHistory();

    function handleClose() {
        setOpen(false)
    }

    function hadnleEdit() {
        navigation.push('/update-item', item)
    }

    // function handleTask() {
    //     navigation.push('/commande-item', item)
    // }
    //
    // let warningDekon = false;
    // if (('StockState' in item) && ('Dekon' in item.StockState) && ('warning' in item.StockState.Dekon))
    //     warningDekon = item.StockState.Dekon.warning;
    //
    // let warningCassablanca = false;
    // if (('StockState' in item) && ('Cassablanca' in item.StockState) && ('warning' in item.StockState.Cassablanca))
    //     warningCassablanca = item.StockState.Cassablanca.warning;
    //
    // // let hasBeenOrderedCassablanca = false;
    // // if (('StockState' in item) && ('Cassablanca' in item.StockState) && ('isInOrdered' in item.StockState.Cassablanca))
    // //     hasBeenOrderedCassablanca = item.StockState.Cassablanca.isInOrdered;
    // //
    // // let hasBeenOrderedDekon = false;
    // // if (('StockState' in item) && ('Dekon' in item.StockState) && ('isInOrdered' in item.StockState.Dekon))
    // //     hasBeenOrderedDekon = item.StockState.Dekon.isInOrdered;
    //
    // const [isOrderModalShown, setIsOrderModalShown] = useState(false);
    //
    // const handleOrderModalClose = () => {
    //     setIsOrderModalShown(false);
    // }
    //
    // const handleOrderModalShow = () => {
    //     // handleClose()
    //     // setTimeout(()=>setIsOrderModalShown(true),5000)
    //     setIsOrderModalShown(true);
    // }

    return (
        <>
            <div>
                <Dialog fullWidth maxWidth="md" onClose={handleClose}
                        aria-labelledby="customized-dialog-title" open={open}>

                    <DialogActions style={{justifyContent: "space-between"}}>
                        <Typography>{item.Name}</Typography>

                        <div>

                            <Button onClick={hadnleEdit} color="primary" variant="contained">
                                Edit
                            </Button>

                            {" "}
                            <Button onClick={handleClose} color="secondary" variant="outlined">
                                Fermer
                            </Button>
                        </div>
                    </DialogActions>

                    <DialogContent dividers>
                        <Container maxWidth="lg" className={classes.spaceStyle}>
                            <div className={classes.imageStyle}>
                                <img src={item.ImageUrl} width="100%" height="100%" alt={item.Name}/>
                            </div>
                            <div className={classes.contentStyle}>
                                {/*<Typography>Categorie : {item.Categorie}</Typography>*/}
                                <Typography>Barecode : {item.Barcode}</Typography>
                                <Typography>Prosoft Reference : {item.InternalId}</Typography>
                                {/*<br/>*/}
                                {/*<Typography>Stock Dekon : {item.Stock["Dekon"]}</Typography>*/}
                                {/*<Typography>Stock Casablanca : {item.Stock["Cassablanca"]}</Typography>*/}
                                {/*<Typography>Sell Price : {item.Price} FCFA </Typography>*/}
                                {/*<br/>*/}

                                {/*<Typography>*/}
                                {/*    Produits en rupture*/}
                                {/*</Typography>*/}

                                {/*<div style={{display: "flex", justifyContent: "space-between"}}>*/}
                                {/*    <Typography>Dekon : {!warningDekon ?*/}
                                {/*        <span style={{*/}
                                {/*            backgroundColor: "green",*/}
                                {/*            color: "white",*/}
                                {/*            padding: "5px",*/}
                                {/*            borderRadius: 20*/}
                                {/*        }}>OUI</span> :*/}
                                {/*        <span style={{*/}
                                {/*            backgroundColor: "red",*/}
                                {/*            color: "white",*/}
                                {/*            padding: "5px",*/}
                                {/*            borderRadius: 20*/}
                                {/*        }}>NON</span>}*/}
                                {/*    </Typography>*/}

                                {/*    <Typography>Cassablanca : {!warningCassablanca ?*/}
                                {/*        <span style={{*/}
                                {/*            backgroundColor: "green",*/}
                                {/*            color: "white",*/}
                                {/*            padding: "5px",*/}
                                {/*            borderRadius: 20*/}
                                {/*        }}>OUI</span> :*/}
                                {/*        <span style={{*/}
                                {/*            backgroundColor: "red",*/}
                                {/*            color: "white",*/}
                                {/*            padding: "5px",*/}
                                {/*            borderRadius: 20*/}
                                {/*        }}>NON</span>}*/}
                                {/*    </Typography>*/}
                                {/*</div>*/}
                                {/*<br/>*/}
                                {/*<br/>*/}


                                {/*<div style={{display: "flex", justifyContent: "space-between"}}>*/}
                                {/*    <Typography>Produit périssable : {item.IsExpirationDateRequire ?*/}
                                {/*        <span style={{*/}
                                {/*            backgroundColor: "green",*/}
                                {/*            color: "white",*/}
                                {/*            padding: "5px",*/}
                                {/*            borderRadius: 20*/}
                                {/*        }}>OUI</span> :*/}
                                {/*        <span style={{*/}
                                {/*            backgroundColor: "red",*/}
                                {/*            color: "white",*/}
                                {/*            padding: "5px",*/}
                                {/*            borderRadius: 20*/}
                                {/*        }}>NON</span>}*/}
                                {/*    </Typography>*/}

                                {/*    <Typography>Produit Validé : {item.IsProductValidated ?*/}
                                {/*        <span style={{*/}
                                {/*            backgroundColor: "green",*/}
                                {/*            color: "white",*/}
                                {/*            padding: "5px",*/}
                                {/*            borderRadius: 20*/}
                                {/*        }}>OUI</span> :*/}
                                {/*        <span style={{*/}
                                {/*            backgroundColor: "red",*/}
                                {/*            color: "white",*/}
                                {/*            padding: "5px",*/}
                                {/*            borderRadius: 20*/}
                                {/*        }}>NON</span>}*/}
                                {/*    </Typography>*/}
                                {/*</div>*/}
                                <br/>
                                {
                                    item.ChildItems && item.ChildItems.map((e, i) => (
                                        <div key={i} style={{
                                            float: "left",
                                            margin: "10px",
                                            height: "70px",
                                            display: "flex",
                                            justifyContent: "space-between"
                                        }}>
                                            <img src={e.ImageUrl} width="70px" height="70px" alt=""/>
                                            <span style={{
                                                textAlign: "center",
                                                fontWeight: 'bold',
                                                fontSize: "20px",
                                                marginRight: '10px'
                                            }}>{e.Quantity}</span>
                                            <span style={{
                                                textAlign: "center",
                                                alignContent: "center",
                                                marginTop: '30px'
                                            }}>{e.Name}</span>
                                        </div>
                                    ))
                                }

                            </div>

                        </Container>
                    </DialogContent>

                </Dialog>
            </div>


        </>
    );
}
